export const getChatBotMessagesData = state => state.chatbot.messages.data;
export const isChatBotMessagesLoading = state => state.chatbot.messages.get.loading;
export const getChatBotFormSchemaData = state => state.chatbot.formSchema.data;
export const isChatBotFormSchemaLoading = state => state.chatbot.formSchema.get.loading;
export const getChatBotMessageFromSideBarData = state => state.chatbot.messageFromSideBar.data;
export const getChatBotFeedbackStatusData = state => state.chatbot.feedbackStatus.data;